import { render, staticRenderFns } from "./ModalCadastroAtitude.vue?vue&type=template&id=7a79eb12"
import script from "./ModalCadastroAtitude.vue?vue&type=script&lang=js"
export * from "./ModalCadastroAtitude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports